<template>
  <div class="grid content-start gap-5">
    <div class="grid gap-2">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            Please wait for corrections to load.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base">Now integrated with LanguageTool!</span>
      </div>
      <span v-if="isLoading">The suggestions are loading. Please be patient. This may take 1
        to
        4 minutes depending on the length of your text.</span>
    </div>
    <!-- <div class="border-2 border-primary-main rounded-3xl p-4 mt-16">
      <span class="font-bold text-base">How does this grammar checker work?</span><br /><br />
      <p>WriteWise has integrated OpenAI's GPT-4 into its grammar-checking system. This integration brings sophisticated
        language processing technology to enhance the grammar-checking capabilities. This involves:</p>
      <ol class="list-decimal grid gap-4 flex-1 p-4">
        <li><span class="font-bold">Initial Analysis:</span> The tool first provides suggestions for corrections based
          on your text.</li>
        <li><span class="font-bold">Implementation:</span> You apply these suggestions to your text.</li>
        <li><span class="font-bold">Re-checking:</span> Run the checker again to receive new, contextually improved
          suggestions.</li>
        <li><span class="font-bold">Iterative Refinement:</span> Repeat the process for progressively enhanced results,
          leading to a polished final
          document.</li>
      </ol>
      <p>This iterative approach ensures comprehensive, context-aware corrections tailored to your writing style,
        leading to more accurate and relevant suggestions with each iteration.</p>
    </div> -->
  </div>
</template>

<script lang="ts">
import TlTextArea from '@/components/global/TlTextArea.vue';
import TlTextField from '@/components/global/TlTextField.vue';
import { Icon } from '@iconify/vue';
import { Vue, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';

@Options({
  components: {
    TlTextArea,
    TlTextField,
    Icon
  }
})
export default class GrammarCheck extends Vue {

  private payloadStore = usePayloadStore();

  public isLoading: boolean = false;

  @Watch('payloadStore.payload.grammarCheckLoading')
  public onGrammarCheckLoading() {
    this.isLoading = this.payloadStore.payload.grammarCheckLoading;
  }

}
</script>
